export enum InspectionStandardType {
	PACP = 'PACP',
	WSA05 = 'WSA05',
}

export interface InspectionType {
	taskName?: string;
	eventName?: string;
	task?: boolean;
	event?: boolean;
	_id: string;
	name: string;
	standard: string;
}

export interface DefectCode {
	code: string;
	desc: string;
}

export interface InspectionTypesStoreState {
	isLoading: boolean;
	inspectionTypeList: InspectionType[];
	codesByStandard: InspectionStandardCodeSet;
}

export type InspectionStandardCodeSet = Record<string, DefectCode[]>;

type FieldMapping = {
	[key: string]: {
		key: string;
		dbFieldName: string;
		display_name: string;
	};
};

export const pacpFieldMappings: FieldMapping = {
	OVERALL_SCORE: {
		key: 'OVERALL_SCORE',
		dbFieldName: 'RATING_INDEX',
		display_name: 'Overall Rating Index',
	},
	STRUCTURAL_SCORE: {
		key: 'STRUCTURAL_SCORE',
		dbFieldName: 'STRUCTURAL_RATING_INDEX',
		display_name: 'Structural Rating Index',
	},
	'O&M_SCORE': {
		key: 'O&M_SCORE',
		dbFieldName: 'SERVICE_RATING_INDEX',
		display_name: 'O&M Rating Index',
	},
	PEAK_OVERALL_QUICK_SCORE: {
		key: 'PEAK_OVERALL_QUICK_SCORE',
		dbFieldName: 'PEAK_OVERALL_QUICK_SCORE',
		display_name: 'Peak Overall Quick Score',
	},
	SECONDARY_OVERALL_QUICK_SCORE: {
		key: 'SECONDARY_OVERALL_QUICK_SCORE',
		dbFieldName: 'SECONDARY_OVERALL_QUICK_SCORE',
		display_name: 'Secondary Overall Quick Score',
	},
	PEAK_STRUCTURAL_QUICK_SCORE: {
		key: 'PEAK_STRUCTURAL_QUICK_SCORE',
		dbFieldName: 'PEAK_STRUCTURAL_QUICK_SCORE',
		display_name: 'Peak Structural Quick Score',
	},
	SECONDARY_STRUCTURAL_QUICK_SCORE: {
		key: 'SECONDARY_STRUCTURAL_QUICK_SCORE',
		dbFieldName: 'SECONDARY_STRUCTURAL_QUICK_SCORE',
		display_name: 'Secondary Structural Quick Score',
	},
	'PEAK_O&M_QUICK_SCORE': {
		key: 'PEAK_O&M_QUICK_SCORE',
		dbFieldName: 'PEAK_OM_QUICK_SCORE',
		display_name: 'Peak O&M Quick Score',
	},
	'SECONDARY_O&M_QUICK_SCORE': {
		key: 'SECONDARY_O&M_QUICK_SCORE',
		dbFieldName: 'SECONDARY_OM_QUICK_SCORE',
		display_name: 'Secondary O&M Quick Score',
	},
	OVERALL_RATING: {
		key: 'OVERALL_RATING',
		dbFieldName: 'OVERALL_RATING',
		display_name: 'Overall Rating',
	},
	STRUCTURAL_RATING: {
		key: 'STRUCTURAL_RATING',
		dbFieldName: 'STRUCTURAL_OVERALL_RATING',
		display_name: 'Structural Rating',
	},
	'O&M_RATING': {
		key: 'O&M_RATING',
		dbFieldName: 'SERVICE_OVERALL_RATING',
		display_name: 'O&M Rating',
	},
};

export const wsaFieldMappings: FieldMapping = {
	STRUCTURAL_GRADE: {
		key: 'STRUCTURAL_GRADE',
		dbFieldName: 'STRUCTURAL_GRADE_RATING',
		display_name: 'Structural Grade',
	},
	STRUCTURAL_TOTAL_SCORE: {
		key: 'STRUCTURAL_TOTAL_SCORE',
		dbFieldName: 'STRUCTURAL_TOTAL_RATING',
		display_name: 'Structural Total Score',
	},
	STRUCTURAL_MEAN_SCORE: {
		key: 'STRUCTURAL_MEAN_SCORE',
		dbFieldName: 'STRUCTURAL_MEAN_RATING',
		display_name: 'Structural Mean Score',
	},
	STRUCTURAL_AVERAGE_SCORE: {
		key: 'STRUCTURAL_AVERAGE_SCORE',
		dbFieldName: 'STRUCTURAL_AVERAGE_RATING',
		display_name: 'Structural Average Score',
	},
	STRUCTURAL_PEAK_SCORE: {
		key: 'STRUCTURAL_PEAK_SCORE',
		dbFieldName: 'STRUCTURAL_PEAK_RATING',
		display_name: 'Structural Peak Score',
	},
	STRUCTURAL_NUM_SCORE: {
		key: 'STRUCTURAL_NUM_SCORE',
		dbFieldName: 'STRUCTURAL_NUM_RATING',
		display_name: 'Structural Num Score',
	},
	SERVICE_GRADE: {
		key: 'SERVICE_GRADE',
		dbFieldName: 'SERVICE_GRADE_RATING',
		display_name: 'Service Grade',
	},
	SERVICE_TOTAL_SCORE: {
		key: 'SERVICE_TOTAL_SCORE',
		dbFieldName: 'SERVICE_TOTAL_RATING',
		display_name: 'Service Total Score',
	},
	SERVICE_MEAN_SCORE: {
		key: 'SERVICE_MEAN_SCORE',
		dbFieldName: 'SERVICE_MEAN_RATING',
		display_name: 'Service Mean Score',
	},
	SERVICE_AVERAGE_SCORE: {
		key: 'SERVICE_AVERAGE_SCORE',
		dbFieldName: 'SERVICE_AVERAGE_RATING',
		display_name: 'Service Average Score',
	},
	SERVICE_PEAK_SCORE: {
		key: 'SERVICE_PEAK_SCORE',
		dbFieldName: 'SERVICE_PEAK_RATING',
		display_name: 'Service Peak Score',
	},
	SERVICE_NUM_SCORE: {
		key: 'SERVICE_NUM_SCORE',
		dbFieldName: 'SERVICE_NUM_RATING',
		display_name: 'Service Num Score',
	},
};
